"use client";

// Small visual chip for a hotkey, used in the palette rows and the
// keyboard shortcuts page. Each modifier renders as its own pill so
// "⌘ ⇧ R" is readable; on Linux/Windows it becomes "Ctrl Shift R".
import { renderToParts } from "@/lib/commands/hotkey";
import type { Hotkey } from "@/lib/commands/types";

export function HotkeyHint({ hotkey }: { hotkey: Hotkey }) {
  const parts = renderToParts(hotkey);
  return (
    <span
      className="ml-auto flex items-center gap-1"
      aria-label={parts.join("+")}
    >
      {parts.map((p, i) => (
        <kbd
          key={`${p}-${i}`}
          className="inline-flex h-5 min-w-5 items-center justify-center rounded border bg-muted px-1 font-mono text-[10px] uppercase text-muted-foreground"
        >
          {p}
        </kbd>
      ))}
    </span>
  );
}
